exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth-callback-panel{width:100%;height:calc(100vh - 64px)}.auth-callback-panel .google-maps-container{width:100%;height:calc(100vh - 64px);position:absolute;top:64px;right:0}.auth-callback-panel .auth-callback-content{width:100%;height:100%;background:rgba(0,0,0,.5);position:fixed;top:0;left:0;z-index:120;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.auth-callback-panel .auth-callback-content>img{display:block;width:100px;height:auto;margin:auto}", ""]);

// exports
